import accounting from 'accounting'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
  // ==========================================================================================================
  //  common
  // ==========================================================================================================
  redirectUrl: function () {
    location.href = '/login'
  },
  // ==========================================================================================================
  //  StringPlus
  // ==========================================================================================================
  // 格式化字符串
  format: function (s, formatString) {
    if (formatString === '') {
      return s
    }

    if (formatString === 'money') {
      return accounting.formatNumber(s, 2)
    }

    if (formatString === 'number') {
      return accounting.formatNumber(s, 2, '')
    }
  },
  formatTableCell: function (s, columnSet, dept, mode) {
    let cellValue = s
    let formatString = columnSet.formatString
    if (formatString === 'money') {
      cellValue = accounting.formatNumber(s, 2)
    }
    if (dept) {
      if (columnSet.columnProp === 'deptNo') {
        cellValue = dept.deptNo
      }
      if (columnSet.columnProp === 'deptName') {
        cellValue = dept.shortName
      }
    }
    if (mode) {
      cellValue = mode.modeName
    }
    return cellValue
  },
  // 金额小写转大写
  digitUppercase: function (n) {
    let fraction = ['角', '分']
    let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    let unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
    let head = n < 0 ? '欠' : ''
    n = Math.abs(n)
    let s = ''
    for (let i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
    }
    s = s || '整'
    n = Math.floor(n)
    for (let i = 0; i < unit[0].length && n > 0; i++) {
      let p = ''
      for (let j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p
        n = Math.floor(n / 10)
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
  },
  // 验证字符串是否是数字
  isNumber: function(v) {
    var reg = /^[-]?[0-9]+.?[0-9]*$/
    if (reg.test(v)) {
      return true
    }
    return false
  },
  // 验证字符串是否是金额
  isMoney: function(v) {
    var reg = /(^[-]?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
    if (reg.test(v)) {
      return true
    }
    return false
  },
  // 验证手机号格式
  isMobile: function(v) {
    var reg = /^1[3-9]{1}[0-9]{9}$/
    if (reg.test(v)) {
      return true
    }
    return false
  },
  // 验证身份证格式
  isUid: function(v) {
    var reg = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
    var reg1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/
    if (reg.test(v) || reg1.test(v)) {
      return true
    }
    return false
  },
  // Excel导入值处理
  validCellValue: function (cellValue, dataType) {
    let v = cellValue || ''
    let valid = true
    switch (dataType) {
      case '02': // 结果是数字
        v = v === '' ? '0' : v
        valid = this.isNumber(v)
        break
      default:
        break
    }
    return valid
  },
  // Excel导入值处理
  getCellValue: function (cellValue, dataType) {
    let v = cellValue || ''
    switch (dataType) {
      case '02': // 结果是数字
        v = v === '' ? '0' : v
        break
      default:
        break
    }
    return v
  },
  // ==========================================================================================================
  //  DatePlus
  // ==========================================================================================================
  // 获取系统默认的日期（根据实际系统确定）
  getDefaultDate: function () {
    return this.dateAdd(new Date(), -1)
  },
  getMonthFirstDay: function (d) {
    var t = new Date(d) // 复制并操作新对象，避免改动原对象
    t.setDate(1)
    return t
  },
  // 当月首日
  getCurMonthFirstDay: function () {
    return new Date()
  },
  // 上月首日
  getPrevMonthFirstDay: function (d) {
    var t = new Date(d) // 复制并操作新对象，避免改动原对象
    return this.monthAdd(this.getMonthFirstDay(t), -1)
  },
  // 上月末
  getPrevMonthEndDay: function () {
    return new Date()
  },
  // 年初
  getCurYearFirstDay: function (d) {
    let result = this.dateToInt(d)
    result = result.toString().substr(0, 4) + '01'

    return this.intToDate(result)
  },
  // 上年末
  getPrevYearEndDay: function () {
    return new Date()
  },
  // 在当前日期上增加天数 d: 当前日期 n: 增加的天数
  dateAdd: function (d, n) {
    var t = new Date(d) // 复制并操作新对象，避免改动原对象
    t.setDate(t.getDate() + n)
    return t
  },
  monthAdd: function (d, n) {
    var t = new Date(d) // 复制并操作新对象，避免改动原对象
    t.setMonth(t.getMonth() + n)
    return t
  },
  dateToInt: function (d) {
    return moment(d).format('YYYYMMDD')
  },
  intToDate: function (d) {
    return moment(d, 'YYYYMMDD').toDate()
  },
  getTimeStamp: function (d) {
    return moment(d).format('YYYYMMDDHHmmss')
  },
  getToday: function (d) {
    return moment(d).format('YYYY-MM-DD')
  },
  getTodayTime: function (d) {
    return moment(d).format('YYYY-MM-DD HH:mm:ss')
  },
  // formatString: YYYYMMDD, YYYY-MM-DD
  getDateByFormat: function (d, formatString) {
    return moment(d).format('YYYY-MM-DD')
  },
  // ==========================================================================================================
  //  TableRender
  // ==========================================================================================================
  // 获取同组记录
  getHeaderGroup: function (item, level, uiSetList) {
    var newColumnList = []
    // 筛选字符串(例：当前列名为【A|B|C】则第2层筛选为 A ; 第3层筛选为 A|B 依此类推)
    var match = ''
    var captions = item.columnDesc.split('|')
    // 标题层数比实际层数大或者相等才开始筛选
    if (captions.length >= level) {
      // 匹配字符串永远比层数少一层
      for (var i = 0; i < level - 1; i++) {
        match = match + captions[i] + '|'
      }
    }
    // match = match.substring(0, match.length - 1) // 去掉最后的'|'号匹配

    // 筛选同组记录
    uiSetList.filter(function (element) {
      // console.log('第 ' + level + ' 层：match=' + match)
      return element.columnDesc.indexOf(match) >= 0 && captions.length >= level
    }).forEach(function (element) {
      // 同级包含相同match的只加一次
      if (newColumnList.filter(function (newItem) {
        return newItem.columnDesc.split('|')[level - 1] === element.columnDesc.split('|')[level - 1]
      }).length === 0) {
        newColumnList.push(element)
      }
    })
    // console.log('第 ' + level + ' 层：列名： = ' + item.columnDesc + '；新列表数 = ' + newColumnList.length)
    return newColumnList
  },
  // 列可见性
  getHeaderVisible: function (item, level, fixed) {
    var visible = false
    if (fixed) {
      // 配置为不可见的列不展示在表格中
      if (item.queryVisible === '1' && item.columnType !== '02' && item.isFixCol === fixed) {
        // 第一层只有isGroupStart配置为【1】的列显示
        if (level === 1) {
          visible = item.isGroupStart === '1'
        } else {
          visible = item.columnDesc.split('|').length >= level
        }
      }
    } else {
      if (item.queryVisible === '1' && item.columnType !== '02') {
        // 第一层只有isGroupStart配置为【1】的列显示
        if (level === 1) {
          visible = item.isGroupStart === '1'
        } else {
          visible = item.columnDesc.split('|').length >= level
        }
      }
    }

    // if (item.queryVisible === '1' && item.columnType === '03' && item.isFixCol === fixed) {
    //   visible = true
    // }
    return visible
  },
  // 操作列可见性
  getOpVisible: function (uiSetList) {
    var visible = false
    if (uiSetList.filter(function (element) {
      return element.columnType === '02' && element.queryVisible === '1'
    }).length > 0) {
      visible = true
    }
    return visible
  },
  // 列是否固定设置
  getColumnFixed: function (item) {
    return item.isFixCol === '1' ? 'left' : false
  },
  // 对象拷贝
  cloneObj: function (obj) {
    var newObj = {}
    if (obj instanceof Array) {
      newObj = []
    }
    for (var key in obj) {
      var val = obj[key]
      newObj[key] = typeof val === 'object' ? this.cloneObj(val) : val
    }
    return newObj
  },
  // 构建交叉表
  createCrossTable1: function (crossResultList, crossItemList, uiSetList, uiSet) {
    // console.log(uiSet, crossResultList, crossItemList)
    var self = this
    var resultList = []
    // ==========================构建固定列===========================
    crossResultList.forEach(function (item) {
      var row = {}
      // 取每一行的固定列
      uiSetList.forEach(function (column) {
        if (column.isCross !== '1') {
          row[column.columnProp] = item[column.columnProp]
        }
      })
      // 去重复
      var t = resultList.filter(function (element) {
        var isMatch = true
        uiSetList.filter(function (matchKey) {
          return matchKey.isUnique === '1'
        })
        .forEach(function (key) {
          isMatch = isMatch && element[key.columnProp] === item[key.columnProp]
        })
        return isMatch
      })

      // 结果集逐行添加固定列部分
      if (t.length === 0) {
        resultList.push(row)
      }
    })
    // console.log('固定列结果集：', resultList)
    // ==========================构建交叉列===========================
    var crossColumnSet = [] // 根据交叉项产生的新列设置
    crossItemList.forEach(function (item) {
      // console.log(':: 当前交叉项：' + item.itemName)

      // 筛选符合当前交叉项的列
      var tmpList = crossResultList.filter(function (element) {
        var isMatch = true
        uiSet.crossItemNo.split(',').forEach(function (key) {
          // console.log('key:', key, 'item:', item[key])
          isMatch = isMatch && element[key] === item[key]
        })
        return isMatch
      })
      // console.log('tmpList:length=' + tmpList.length)
      // console.log('当前列结果集tmpList=', tmpList)

      // ==========================填充当前行的当前交叉项的属性(构造新的uiSetList)==============================
      uiSetList.forEach(function (column) {
        // 配置了几个交叉项数据就增加几个属性
        if (column.isCross === '1') {
          // console.log('当前交叉列为：' + column.columnProp)
          // 重构新列名
          var newColumnName = column.columnProp
          uiSet.crossItemNo.split(',').forEach(function (key) {
            newColumnName = newColumnName + item[key]
          })
          // console.log('当前新列名：' + newColumnName)

          // 将新列的设置加入columnSet
          var newColumnSet = self.cloneObj(column)
          // console.log('当前新列设置：' + newColumnSet.columnDesc)
          // 更新属性（列名、列属性，其他不变）
          newColumnSet.columnProp = newColumnName
          newColumnSet.columnName = newColumnName
          newColumnSet.isCross = '0'
          newColumnSet.columnDesc = ''

          uiSet.crossItemName.split(',').forEach(function (key) {
            // console.log('key:', key, 'item:', item[key])
            newColumnSet.columnDesc = newColumnSet.columnDesc + item[key]
            newColumnSet.columnDesc = newColumnSet.columnDesc + '|'
          })
          newColumnSet.columnDesc = newColumnSet.columnDesc.substring(0, newColumnSet.columnDesc.length - 1) // 去掉末尾的‘|’号
          item.sortNo = item.sortNo || '99'

          newColumnSet.sortNo = newColumnSet.sortNo + '|' + item.sortNo // 编辑界面顺序
          newColumnSet.sortNoResult = newColumnSet.sortNoResult + '|' + item.sortNo // 查询结果顺序
          // console.log('更改后新列设置：列名：' + newColumnSet.columnDesc + '; 属性名：' + newColumnSet.columnDesc)
          // console.log('原始列设置：列名：' + column.columnDesc + '; 属性名：' + column.columnDesc)

          // 设置多层表头的组起始值
          var a = crossColumnSet.filter(function (element) {
            return element.columnDesc.split('|')[0] === newColumnSet.columnDesc.split('|')[0]
          }).length

          if (a === 0) {
            newColumnSet.isGroupStart = '1'
          } else {
            newColumnSet.isGroupStart = '0'
          }

          // 添加到columnSet上
          crossColumnSet.push(newColumnSet)

          // ==============================为结果集填充每一行的交叉项数据===================================
          resultList.forEach(function (row) {
            // 找到符合当前固定列的剩余交叉项部分（只有一条）
            var crossItem = tmpList.filter(function (element) {
              var isMatch = true
              uiSetList.filter(function (matchKey) {
                return matchKey.isUnique === '1'
              }).forEach(function (key) {
                isMatch = isMatch && element[key.columnProp] === row[key.columnProp]
              })
              return isMatch
            })
            // console.log('crossItem===', crossItem)
            if (crossItem.length > 0) {
              row[newColumnName] = crossItem[0][column.columnProp] // 交叉列赋值
            }
          })
        }
      })
    })
    // 清除交叉项数据设置
    uiSetList = uiSetList.filter(function (element) {
      return element.isCross !== '1'
    })
    // 合并columnSet和crossColumnSet
    uiSetList = uiSetList.concat(crossColumnSet)

    var obj = {}
    obj.resultList = resultList
    obj.uiSetList = uiSetList
    // console.log('obj:', obj)

    return obj
  },
  // 构建交叉表
  createCrossTable: function (crossResultList, crossItemList, uiSetList, uiSet) {
    // console.log('yyyyyyyyyyy', crossResultList, crossItemList)
    var self = this
    var resultList = []
    let row = null
    // 前提：先按主键排序
    // ==========================构建交叉表===========================
    crossResultList.forEach(function (item) {
      // console.log('xxxxxxxxxx', resultList, row)
      if (row) {
        // 校验当前行是否与当前row主键匹配
        let isMatch = true
        uiSetList.filter(function (matchKey) {
          return matchKey.isUnique === '1'
        })
        .forEach(function (key) {
          isMatch = isMatch && row[key.columnProp] === item[key.columnProp]
        })

        if (isMatch) { // -----------------------如果匹配上，则赋交叉项的值-----------------
          uiSetList.filter(function (crossItem) {
            return crossItem.isCross === '1'
          }).forEach(function (element) { // 每一个交叉项赋值
            // 构建新列属性名
            let newColumnProp = element.columnProp
            uiSet.crossItemNo.split(',').forEach(function (key) {
              newColumnProp = newColumnProp + item[key] // item[key]主表肯定有
            })
            row[newColumnProp] = item[element.columnProp]
          })
        } else { // ------------------不匹配创建新对象-------------------
          // 先添加原对象
          let tmpObj = self.cloneObj(row)
          resultList.push(tmpObj)
          // 再清空对象重新开始
          row = {}
          // 取每一行的固定列
          uiSetList.forEach(function (column) {
            if (column.isCross !== '1') {
              row[column.columnProp] = item[column.columnProp]
            }
          })
          // 取当前行的交叉项数据
          uiSetList.filter(function (crossItem) {
            return crossItem.isCross === '1'
          }).forEach(function (element) { // 每一个交叉项赋值
            // 构建新列属性名
            let newColumnProp = element.columnProp
            uiSet.crossItemNo.split(',').forEach(function (key) {
              newColumnProp = newColumnProp + item[key] // item[key]主表肯定有
            })
            row[newColumnProp] = item[element.columnProp]
          })
        }
      } else {
        // 第一次循环
        row = {}
        // 取每一行的固定列
        uiSetList.forEach(function (column) {
          if (column.isCross !== '1') {
            row[column.columnProp] = item[column.columnProp]
          }
        })
        // 取当前行的交叉项数据
        uiSetList.filter(function (crossItem) {
          return crossItem.isCross === '1'
        }).forEach(function (element) { // 每一个交叉项赋值
          // 构建新列属性名
          let newColumnProp = element.columnProp
          uiSet.crossItemNo.split(',').forEach(function (key) {
            newColumnProp = newColumnProp + item[key] // item[key]主表肯定有
          })
          row[newColumnProp] = item[element.columnProp]
        })
      }
    })
    // 处理最后一条数据
    if (row) {
      resultList.push(row)
    }
    // console.log('固定列结果集：', resultList)
    // ==========================构建交叉列===========================
    var crossColumnSet = [] // 根据交叉项产生的新列设置
    crossItemList.forEach(function (item) {
      // console.log(':: 当前交叉项：' + item.itemName)
      // console.log('tmpList:length=' + tmpList.length)
      // console.log('当前列结果集tmpList=', tmpList)

      // ==========================填充当前行的当前交叉项的属性(构造新的uiSetList)==============================
      uiSetList.forEach(function (column) {
        // 配置了几个交叉项数据就增加几个属性
        if (column.isCross === '1') {
          // console.log('当前交叉列为：' + column.columnProp)
          // 重构新列名
          var newColumnName = column.columnProp
          uiSet.crossItemNo.split(',').forEach(function (key) {
            newColumnName = newColumnName + item[key]
          })
          // console.log('当前新列名：' + newColumnName)

          // 将新列的设置加入columnSet
          var newColumnSet = self.cloneObj(column)
          // console.log('当前新列设置：' + newColumnSet.columnDesc)
          // 更新属性（列名、列属性，其他不变）
          newColumnSet.columnProp = newColumnName
          newColumnSet.columnName = newColumnName
          newColumnSet.isCross = '0'
          newColumnSet.columnDesc = ''

          uiSet.crossItemName.split(',').forEach(function (key) {
            // console.log('key:', key, 'item:', item[key])
            newColumnSet.columnDesc = newColumnSet.columnDesc + item[key]
            newColumnSet.columnDesc = newColumnSet.columnDesc + '|'
          })
          newColumnSet.columnDesc = newColumnSet.columnDesc.substring(0, newColumnSet.columnDesc.length - 1) // 去掉末尾的‘|’号
          item.sortNo = item.sortNo || '99'

          newColumnSet.sortNo = newColumnSet.sortNo + '|' + item.sortNo // 编辑界面顺序
          newColumnSet.sortNoResult = newColumnSet.sortNoResult + '|' + item.sortNo // 查询结果顺序
          // console.log('更改后新列设置：列名：' + newColumnSet.columnDesc + '; 属性名：' + newColumnSet.columnDesc)
          // console.log('原始列设置：列名：' + column.columnDesc + '; 属性名：' + column.columnDesc)

          // 设置多层表头的组起始值
          var a = crossColumnSet.filter(function (element) {
            return element.columnDesc.split('|')[0] === newColumnSet.columnDesc.split('|')[0]
          }).length

          if (a === 0) {
            newColumnSet.isGroupStart = '1'
          } else {
            newColumnSet.isGroupStart = '0'
          }

          // 添加到columnSet上
          crossColumnSet.push(newColumnSet)
        }
      })
    })
    // 清除交叉项数据设置
    uiSetList = uiSetList.filter(function (element) {
      return element.isCross !== '1'
    })
    // 合并columnSet和crossColumnSet
    uiSetList = uiSetList.concat(crossColumnSet)

    var obj = {}
    obj.resultList = resultList
    obj.uiSetList = uiSetList
    // console.log('obj:', obj)

    return obj
  },
  // sorts形如：[{prop: 'id', order: 'ascending'}, {prop: 'name', order: 'descending'}]
  sort: function (list, sorts) {
    // console.log('sorts', sorts)
    let match = []
    let resultList = []
    var self = this
    sorts.forEach(function (element) {
      resultList = []
      // console.log('list', list)
      // 构建排序
      let tmpList = []
      if (match.length > 0) {
        list.forEach(function (listItem) {
          let obj = {}
          match.forEach(function (matchItem) {
            obj[matchItem.prop] = listItem[matchItem.prop]
          })
          // 只加入不重复的数据
          if (tmpList.length === 0) {
            tmpList.push(obj)
          } else {
            let rep = tmpList.filter(function (tmpItem) {
              let bIsRep = true
              match.forEach(function (matchItem) {
                bIsRep = bIsRep && tmpItem[matchItem.prop] === obj[matchItem.prop]
              })
              return bIsRep
            })
            if (rep.length === 0) {
              tmpList.push(obj)
            }
          }
        })
      }
      // 根据tmpList筛选符合条件的子数组排序
      if (tmpList.length > 0) { // 递归
        tmpList.forEach(function (tmpItem) {
          let childList = list.filter(function (resultItem) {
            let bIsMatch = true
            match.forEach(function (matchItem) {
              bIsMatch = bIsMatch && resultItem[matchItem.prop] === tmpItem[matchItem.prop]
            })
            return bIsMatch
          })
          resultList = resultList.concat(self.sortList(childList, element))
          // console.log('childList:', childList)
        })
        list = resultList
        // console.log('resultList:', resultList)
      } else { // 第一次
        resultList = self.sortList(list, element)
      }
      match.push({prop: element.prop})
    })
    // console.log('resultList:', resultList)
    return resultList
  },
  // 单排序
  sortList: function(list, sort) {
    var resultList = []
    if (sort.order === 'ascending') {
      resultList = list.sort(function (a, b) {
        return a[sort.prop] > b[sort.prop] ? 1 : -1
      })
    } else {
      resultList = list.sort(function (a, b) {
        return b[sort.prop] > a[sort.prop] ? 1 : -1
      })
    }
    return resultList
  },
  // 输出sql初始化脚本
  toSql: function (tableName, uiSetList, resultList) {
    let sqlString = ''
    resultList.forEach(function (element) {
      let insertString = ''
      let valueString = ''
      insertString = insertString + 'insert into ' + tableName + '('
      valueString = valueString + '    values('
      uiSetList.forEach(function (column) {
        if (column.columnType !== '02') {
          insertString = insertString + column.columnName + ', '
          if (element[column.columnProp] === null || element[column.columnProp] === undefined) {
            element[column.columnProp] = ''
          }
          valueString = valueString + '\'' + element[column.columnProp] + '\', '
        }
      })
      insertString = insertString.substr(0, insertString.length - 2) + ')' + '\r\n'
      valueString = valueString.substr(0, valueString.length - 2) + ');' + '\r\n'
      sqlString = sqlString + insertString + valueString
    })
    return sqlString
  },
  // 输出sql初始化脚本
  toJson: function (uiSetList) {
    var self = this
    let jsonString = '[\r\n'
    let objString = '  {'
    uiSetList.forEach(function (element) {
      if (element.columnType !== '02') {
        objString = objString + element.columnProp + ': \'' + self.getDefaultValue(element) + '\', '
      }
    })
    objString = objString.substr(0, objString.length - 2) + '}' + '\r\n'
    jsonString = jsonString + objString
    jsonString = jsonString + ']'
    return jsonString
  },
   // ==========================================================================================================
  //  UIRender
  // ==========================================================================================================
  getDefaultValue: function(uiSetColumn) {
    let defaultValue = ''

    defaultValue = uiSetColumn.defaultValue

    if (uiSetColumn.controlType === '03' || uiSetColumn.controlType === '04') {
      switch (defaultValue) {
        case '':
          defaultValue = new Date()
          break
        case '01': // 系统报表日期
          defaultValue = this.getDefaultDate()
          break
        case '02': // 月初
          defaultValue = this.getDefaultDate()
          break
        case '03': // 年末
          defaultValue = this.getDefaultDate()
          break
        default:
          if (defaultValue.length > 0) {
            defaultValue = this.intToDate(defaultValue)
          }
          break
      }
    }
    return defaultValue
  },
  // 查询条件默认值
  getDefaultValueQuery: function(uiSetColumn) {
    let defaultValue = ''

    defaultValue = uiSetColumn.defaultValueCond || ''

    if (uiSetColumn.controlType === '03' || uiSetColumn.controlType === '04') {
      switch (defaultValue) {
        case '':
          defaultValue = new Date()
          break
        case '01':
          defaultValue = new Date()
          break
        case '02':
          defaultValue = this.getDefaultDate()
          break
        case '03': // 上月初到当日
          defaultValue = [this.getPrevMonthFirstDay(new Date()), new Date()]
          break
        case '04': // 本年初到当日
          defaultValue = [this.getCurYearFirstDay(new Date()), new Date()]
          break
        case '05': // 本月初到当日
          defaultValue = [this.getMonthFirstDay(new Date()), new Date()]
          break
        default:
          if (defaultValue.length > 0) {
            defaultValue = this.intToDate(defaultValue)
          }
          break
      }
    }
    return defaultValue
  },
  // 设置初值，用于导入或者提供给服务使用
  setDefaultValue: function(uiSetColumn) {
    let defaultValue = ''

    defaultValue = uiSetColumn.defaultValue

    if (uiSetColumn.controlType === '03' || uiSetColumn.controlType === '04') {
      switch (defaultValue) {
        case '':
          defaultValue = this.dateToInt(new Date())
          break
        case '01':
          defaultValue = this.dateToInt(new Date())
          break
        case '02':
          defaultValue = this.dateToInt(this.getDefaultDate())
          break
        default:
          break
      }
    }
    return defaultValue.toString()
  },
  // controlType: 01 文本框 02 下拉框 03 日期框 04 日期范围框 05 级联下拉框 06 文本域 07 数字框；
  // selectType: 下拉框类型： 01 数据字典 02 机构
  // item: uiSetItem对象
  getVisibleControlQuery: function (controlType, item, selectType) {
    let visible = true
    if (item.controlType === '01' || item.controlType === '06' || item.controlType === '07') { // 查询条件窗体03 06 07类型的控件都映射为文本框
      visible = visible && controlType === '01'
    } else {
      visible = visible && item.controlType === controlType
    }
    if (controlType === '02' || controlType === '05') {
      if (selectType === '01') {
        visible = visible && item.typeId !== 'Dept'
        visible = visible && item.typeId !== 'Project'
        visible = visible && item.typeId !== 'Staff'
        visible = visible && item.typeId !== 'Term'
      }
      if (selectType === '02') {
        visible = visible && item.typeId === 'Dept'
      }
      if (selectType === '03') {
        visible = visible && item.typeId === 'Project'
      }
      if (selectType === '04') {
        visible = visible && item.typeId === 'Staff'
      }
      if (selectType === '05') {
        visible = visible && item.typeId === 'Term'
      }
    }

    return visible
  },
  // controlType: 01 文本框 02 下拉框 03 日期框 04 日期范围框 05 级联下拉框 06 文本域 07 数字框；
  // selectType: 下拉框类型： 01 数据字典 02 机构 03 项目 04 员工
  // item: uiSetItem对象
  getVisibleControlEdit: function (controlType, item, selectType) {
    let visible = true
    if (item.controlType === '03' || item.controlType === '04') { // 编辑窗体03 04类型的控件都映射为日期框
      visible = visible && controlType === '03'
    } else {
      visible = visible && item.controlType === controlType
    }

    if (controlType === '02' || controlType === '05') {
      if (selectType === '01') {
        visible = visible && item.typeId !== 'Dept'
        visible = visible && item.typeId !== 'Project'
        visible = visible && item.typeId !== 'Staff'
        visible = visible && item.typeId !== 'Term'
      }
      if (selectType === '02') {
        visible = visible && item.typeId === 'Dept'
      }
      if (selectType === '03') {
        visible = visible && item.typeId === 'Project'
      }
      if (selectType === '04') {
        visible = visible && item.typeId === 'Staff'
      }
      if (selectType === '05') {
        visible = visible && item.typeId === 'Term'
      }
    }

    return visible
  },
  // 根据配置初始化窗体对象（用于查询窗体）
  initQueryForm: function (uiSetList, uiSetId) {
    var self = this
    let obj = {}
    uiSetList.filter(function(item) {
      return item.uiSetId === uiSetId && item.columnType !== '02'
    })
    .forEach(function (element) {
      if (element.controlType === '05') {
        obj[element.columnProp + 'Cas'] = []
        obj[element.columnProp] = self.getDefaultValueQuery(element) || ''
      } else if (element.controlType === '04') { // 处理日期范围框
        obj[element.columnProp + 'Range'] = [new Date(), new Date()]
        if (element.defaultValueCond !== '') {
          obj[element.columnProp + 'Range'] = self.getDefaultValueQuery(element)
        }
      } else if (element.controlType === '03') { // 处理日期框
        if (element.queryCondition === '1') {
          obj[element.columnProp] = new Date()
        } else {
          obj[element.columnProp] = 0
        }
      } else {
        obj[element.columnProp] = self.getDefaultValueQuery(element) || ''
      }
    })
    return obj
  },
  // 根据UISet获取默认排序对象
  getDefaultSort: function (uiSet) {
    let sort = []
    if (uiSet.sortSet) {
      let sortList = uiSet.sortSet.split(',')

      let obj = {}
      for (var i = 0; i < sortList.length; i++) {
        if (i % 2 === 1) { // 每两次添加一个对象
          obj.order = sortList[i] === '01' ? 'ascending' : 'descending'
          sort.push(obj)
        }
        if (i % 2 === 0) { // 每两次创建新对象
          obj = {}
          obj.prop = sortList[i]
        }
      }
    }
    return sort
  },
  // 根据配置初始化窗体对象（用于新增和编辑窗体）
  resetForm: function (uiSetList, uiSetId) {
    var self = this
    let obj = {}
    uiSetList.filter(function(item) {
      return item.uiSetId === uiSetId && item.columnType !== '02'
    })
    .forEach(function (element) {
      if (element.controlType === '05') {
        obj[element.columnProp + 'Cas'] = []
        obj[element.columnProp] = self.getDefaultValue(element)
      } else {
        obj[element.columnProp] = self.getDefaultValue(element)
      }
    })
    return obj
  },
  getRuleProp(uiSetColumn) {
    let prop = uiSetColumn.columnProp
    if (uiSetColumn.controlType === '05') {
      prop = prop + 'Cas'
    }
    return prop
  },
  // 根据选中的行赋值窗体对象（用于编辑）-- 注意05类型的控件需要手工处理
  setFormByRow: function (uiSetList, uiSetId, row) {
    var self = this
    let obj = {}
    uiSetList.filter(function(item) {
      return item.uiSetId === uiSetId && item.columnType !== '02'
    })
    .forEach(function (element) {
      if (element.controlType === '03' || element.controlType === '04') {
        if (row[element.columnProp]) {
          obj[element.columnProp] = self.intToDate(row[element.columnProp].toString().replace('-', ''))
        }
      } else {
        obj[element.columnProp] = row[element.columnProp] || ''
        if (element.controlType !== '02' && element.controlType !== '05') {
          obj[element.columnProp] = obj[element.columnProp].toString()
        }
        if (element.controlType === '05') {
          obj[element.columnProp + 'Cas'] = []
        }
        if (row[element.columnProp] === 0) {
          obj[element.columnProp] = '0'
        }
      }
    })
    return obj
  },
  getEditItemClass: function (inline) {
    if (inline) {
      return 'edit-form-item'
    } else {
      return ''
    }
  },
  // 组织树方法
  // pId: 父ID的属性名
  // id: ID的属性名
  // label: 显示属性名
  getTree: function (resultList, parentId, pId, id, label) {
    var self = this
    let treeList = []
    resultList.filter(function (element) { // 筛选与父ID相同的记录
      if (element[pId] === parentId) {
        return element
      }
    }).forEach(function (element) {
      let tmpList = resultList.filter(function (e) { // 筛选是否有子
        return e[pId] === element[id]
      })

      let node = {}
      node.label = element[label]
      node.value = element[id]

      if (tmpList.length > 0) { // 如果有子
        // 递归
        node.children = self.getTree(resultList, element[id], pId, id, label)
        treeList.push(node)
      } else {
        treeList.push(node)
      }
    })
    return treeList
  },
  // ==========================================================================================================
  //  业务
  // ==========================================================================================================
  // 取当前机构对应的客户信息
  getCustomerByDeptId: function (deptList, customerList, deptId) {
    let customer = []

    customer = customerList.filter(function(element) {
      return element.deptId === deptId
    })

    if (customer.length === 0) {
      let dept = deptList.filter(function (element) {
        return element.deptId === deptId
      })
      if (dept.length > 0) {
        deptId = dept[0].parentDeptId
        customer = this.getCustomerByDeptId(deptList, customerList, deptId)
      }
    }
    return customer
  },
  // 取当前机构对应的客户商户信息
  getMerchantByDeptId: function (deptList, merchantList, deptId) {
    let merchant = []

    merchant = merchantList.filter(function(element) {
      return element.deptId === deptId
    })

    if (merchant.length === 0) {
      let dept = deptList.filter(function (element) {
        return element.deptId === deptId
      })
      if (dept.length > 0) {
        deptId = dept[0].parentDeptId
        merchant = this.getMerchantByDeptId(deptList, merchantList, deptId)
      }
    }
    return merchant
  },
  // 判断当前机构是否是顶级机构(客户映射的机构)
  IsTopDept: function (deptId, customerList) {
    let customer = customerList.filter(function(element) {
      return element.deptId === deptId
    })
    if (customer.length > 0) {
      return true
    } else {
      return false
    }
  },
  // 取有客户对应的机构列表
  getDeptListForSet: function (customerList, deptList) {
    let deptListForSet = []
    customerList.forEach(function (element) {
      let dept = deptList.filter(item => item.deptId === element.deptId)
      if (dept.length > 0) {
        // 只加入不重复的数据
        if (deptListForSet.length === 0) {
          deptListForSet.push(dept[0])
        } else {
          let rep = deptListForSet.filter(function (deptItem) {
            return deptItem.deptId === element.deptId
          })
          if (rep.length === 0) {
            deptListForSet.push(dept[0])
          }
        }
      }
    })
    let sorts = [{prop: 'deptLevel', order: 'ascending'}, {prop: 'sortNo', order: 'ascending'}]
    deptListForSet = this.sort(deptListForSet, sorts)
    return deptListForSet
  },
  // 根据传入的机构列表筛选所有叶子节点或者某一个父级节点的所有叶子节点
  // deptList: 传入的机构列表
  // parent： 限制条件，取该机构的所有子(仅叶子)
  getDeptLeaf: function (deptList, parent) {
    let leafList = []
    deptList.forEach(function (dept) {
      let tmpList = deptList.filter(function (element) {
        return element.parentDeptId === dept.deptId
      })
      if (tmpList.length === 0) { // 没有子的才加
        if (parent) {
          if (dept.fullNodeId.indexOf(parent.fullNodeId) >= 0) {
            leafList.push(dept)
          }
        } else {
          leafList.push(dept)
        }
      }
    })
    return leafList
  },
  // 根据传入的机构列表筛选该机构及其子机构
  // deptList: 传入的机构列表
  // deptId 限制条件，取该机构的所有子
  getDeptChild: function (deptList, deptId) {
    let child = []
    let dept = deptList.filter(element => element.deptId === deptId)
    if (dept) {
      child = deptList.filter(function (item) {
        return item.fullNodeId.indexOf(dept[0].fullNodeId) >= 0
      })
    }
    return child
  },
  // 获取顺序中第一个叶子节点
  getFirstDeptLeaf: function (deptList) {
    let leaf = {}
    for (var i = 0; i < deptList.length; i++) {
      let tmpList = deptList.filter(function (element) {
        return element.parentDeptId === deptList[i].deptId
      })
      if (tmpList.length === 0) { // 没有子的才加
        leaf = deptList[i]
        break
      }
    }
    return leaf
  },
  // 获取当前叶子机构的级联值（用于赋默认值）
  getDeptCascader: function (deptList, leaf) {
    let deptIdCas = []
    if (leaf) {
      let parent = deptList.filter(element => element.deptId === leaf.parentDeptId)
      if (parent) {
        deptIdCas.push(leaf.deptId)
        deptIdCas = this.getDeptCascader(deptList, parent[0]).concat(deptIdCas)
      } else {
        deptIdCas.push(leaf.deptId)
      }
    }
    return deptIdCas
  },
  // 获取机构列表的最大机构号
  getMaxDeptNo: function (deptleafList) {
    let deptNo = ''
    let list = deptleafList.filter(function (element) {
      return element.deptType === '07'
    })
    if (list.length === 0) {
      deptNo = '001'
    } else {
      let sort = {prop: 'deptNo', order: 'descending'}
      list = this.sortList(list, sort)
      // deptNo = (parseInt(list[0].deptNo) + 1).toString()
      deptNo = (1000 + (parseInt(list[0].deptNo) + 1)).toString().substring(1)
    }
    return deptNo
  },
  // 获取机构列表的最大排序号
  getMaxSortNo: function (deptleafList) {
    let sortNo = ''
    let list = deptleafList.filter(function (element) {
      return element.deptType === '07'
    })
    if (list.length === 0) {
      sortNo = '001'
    } else {
      let sort = {prop: 'sortNo', order: 'descending'}
      list = this.sortList(list, sort)
      sortNo = (1000 + (parseInt(list[0].sortNo) + 1)).toString().substring(1)
    }
    return sortNo
  },
  getHeaderAlign: function (item) {
    let align = 'left'
    if (item.dataType === '02') {
      align = 'right'
    }
    return align
  },
  getUuid: function () {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23]
    var uuid = s.join('')
    return uuid
  },
  // 脱敏-将传入字符串全部替换成*号
  getStar: function (s) {
    return s.replace(/[\w\W]/g, '*')
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Ginkgo.js